// extracted by mini-css-extract-plugin
export default {"container":"Home_container__AHomM","title":"Home_title__qAdt+","message":"Home_message__mROLv","button":"Home_button__sTIln"};